import reinigungHero from "@/assets/reinigung-hero.png.asset.json";
import reinigungsserviceHero from "@/assets/reinigungsservice-hero.png.asset.json";
import itHero from "@/assets/it-hero.jpg.asset.json";
import winterHero from "@/assets/winterdienst-hero-photo.png.asset.json";
import elektroHero from "@/assets/elektro-hero.png.asset.json";
import hausmeisterHero from "@/assets/hausmeister-hero.jpg.asset.json";
import cleaningResult from "@/assets/cleaning-result-1.jpg.asset.json";

export interface LocalSeoSection {
  h2: string;
  paragraphs: string[];
}

export interface LocalSeoPage {
  slug: string;
  keyword: string;
  title: string;
  description: string;
  h1: string;
  eyebrow: string;
  heroAlt: string;
  image: string;
  serviceType: string;
  intro: string[];
  sections: LocalSeoSection[];
  areasText: string;
  faq: { q: string; a: string }[];
  related: { to: string; label: string }[];
}

export const localSeoPages: LocalSeoPage[] = [
  {
    slug: "bueroreinigung-hanau",
    keyword: "Büroreinigung Hanau",
    title: "Büroreinigung Hanau: Saubere Büros | ManageMatch",
    description:
      "Büroreinigung Hanau: feste Zeiten, geprüfte Teams, ein Ansprechpartner. Wir organisieren Ihre Büroreinigung. Jetzt kostenloses Angebot anfragen.",
    h1: "Büroreinigung Hanau für kleine und große Teams",
    eyebrow: "Büro & Gewerbe",
    heroAlt: "Büroreinigung Hanau: gereinigter Arbeitsplatz in einem hellen Büro",
    image: reinigungsserviceHero.url,
    serviceType: "Büroreinigung",
    intro: [
      "Sie suchen eine Büroreinigung Hanau, die einfach läuft, ohne dass Sie ständig nachhaken müssen? Genau darum kümmern wir uns. ManageMatch organisiert die Reinigung Ihrer Büroflächen mit festen Teams, klaren Zeiten und einem Ansprechpartner, der erreichbar ist, wenn mal etwas nicht passt.",
      "Ob Kanzlei in der Innenstadt, Praxis am Freiheitsplatz oder Agentur im Gewerbegebiet Wolfgang: Wir hören zuerst zu, schauen uns die Räume an und stimmen einen Plan ab, der zu Ihrem Alltag passt. Kein Standardpaket, das an der Realität vorbeigeht.",
    ],
    sections: [
      {
        h2: "Was bei der Büroreinigung Hanau dazugehört",
        paragraphs: [
          "Zur laufenden Unterhaltsreinigung gehören Schreibtische, Böden, Küche, Sanitärbereiche und das Leeren der Papierkörbe. Dazu kommen Dinge, die gern vergessen werden: Türklinken, Lichtschalter, Glastüren und die Kaffeemaschine, an der sich morgens das halbe Team trifft.",
          "Auf Wunsch planen wir zusätzlich Grundreinigungen, Fensterreinigung oder eine Teppichpflege ein. Alles läuft über denselben Kontakt, damit Sie nicht drei Firmen koordinieren müssen.",
        ],
      },
      {
        h2: "So läuft die Zusammenarbeit",
        paragraphs: [
          "Am Anfang steht ein kurzes Gespräch, gern auch direkt vor Ort. Danach bekommen Sie ein transparentes Angebot mit Leistungsumfang und Intervallen. Wenn es passt, legen wir los, meistens innerhalb weniger Tage.",
          "Die Reinigung findet dann statt, wann es Ihnen passt: früh morgens, abends nach Feierabend oder am Wochenende. Wir sind sieben Tage die Woche von 08:00 bis 20:00 Uhr erreichbar und reagieren schnell, wenn sich etwas ändert, etwa weil ein Umzug ansteht oder neue Räume dazukommen.",
        ],
      },
      {
        h2: "Warum ein fester Ansprechpartner so viel ausmacht",
        paragraphs: [
          "Viele Büros kennen das: Die Reinigung ist mal gut, mal eher nicht, und niemand fühlt sich zuständig. Bei uns gibt es eine Person, die Ihr Objekt kennt, Rückmeldungen aufnimmt und dafür sorgt, dass sie beim nächsten Termin umgesetzt werden.",
          "Das spart Ihnen Zeit, Nerven und ziemlich viele E-Mails. Und Ihr Team kommt morgens in ein Büro, in dem man gern arbeitet.",
        ],
      },
    ],
    areasText:
      "Wir organisieren Büroreinigung in ganz Hanau, von Steinheim über Großauheim bis Kesselstadt, und in den Nachbarorten.",
    faq: [
      { q: "Wie oft sollte ein Büro gereinigt werden?", a: "Das hängt von Größe und Nutzung ab. Die meisten Büros mit bis zu 20 Arbeitsplätzen fahren gut mit zwei bis drei Terminen pro Woche. Sanitär und Küche brauchen oft mehr Aufmerksamkeit als Einzelbüros." },
      { q: "Kann die Reinigung außerhalb der Arbeitszeit stattfinden?", a: "Ja. Wir planen die Termine so, dass Ihr Betrieb nicht gestört wird, zum Beispiel früh am Morgen oder nach Feierabend." },
      { q: "Was kostet eine Büroreinigung in Hanau?", a: "Das Angebot richtet sich nach Fläche, Intervall und Leistungsumfang. Nach einer kurzen Besichtigung bekommen Sie einen festen Preis ohne versteckte Posten." },
      { q: "Muss ich Reinigungsmittel stellen?", a: "Nein. Material und Geräte bringt das Team mit. Wenn Sie bestimmte Produkte bevorzugen, berücksichtigen wir das gern." },
    ],
    related: [
      { to: "/reinigung-hanau", label: "Reinigung in Hanau für Wohnungen und Treppenhäuser" },
      { to: "/bueroreinigung-aschaffenburg", label: "Büroreinigung in Aschaffenburg" },
      { to: "/dienstleister-koordinieren", label: "Alle Dienstleister über einen Ansprechpartner" },
    ],
  },
  {
    slug: "bueroreinigung-aschaffenburg",
    keyword: "Büroreinigung Aschaffenburg",
    title: "Büroreinigung Aschaffenburg: Planbar sauber | ManageMatch",
    description:
      "Büroreinigung Aschaffenburg mit festen Teams und klaren Terminen. ManageMatch organisiert alles für Sie. Jetzt unverbindlich Angebot anfragen.",
    h1: "Büroreinigung Aschaffenburg ohne Stress",
    eyebrow: "Büro & Gewerbe",
    heroAlt: "Büroreinigung Aschaffenburg: saubere Büroküche und Arbeitsplätze",
    image: reinigungHero.url,
    serviceType: "Büroreinigung",
    intro: [
      "Eine gute Büroreinigung Aschaffenburg merkt man eigentlich nur daran, dass man nicht an sie denken muss. Die Böden sind sauber, der Müll ist weg, die Küche riecht nicht nach gestern. ManageMatch organisiert genau das für Unternehmen am bayerischen Untermain.",
      "Wir sitzen in Hanau, arbeiten aber regelmäßig für Kunden in Aschaffenburg, von der Innenstadt bis zu den Gewerbeflächen in Nilkheim und Leider. Die Anfahrt ist kurz, die Wege sind eingespielt.",
    ],
    sections: [
      {
        h2: "Büroreinigung Aschaffenburg, die zu Ihrem Betrieb passt",
        paragraphs: [
          "Ein Steuerbüro hat andere Anforderungen als ein Showroom oder ein Coworking Space. Deshalb schauen wir uns erst an, wie Ihre Räume genutzt werden: Wo ist viel Laufverkehr? Gibt es Besprechungsräume mit Kundenkontakt? Welche Bereiche brauchen täglich Pflege und welche nur einmal pro Woche?",
          "Daraus entsteht ein Reinigungsplan, der nicht mehr kostet als nötig und trotzdem alles abdeckt, was wirklich zählt.",
        ],
      },
      {
        h2: "Zuverlässigkeit statt ständig neuer Gesichter",
        paragraphs: [
          "Wir setzen auf feste Teams, die Ihr Objekt kennen. Das hat einen einfachen Grund: Wer die Räume kennt, arbeitet gründlicher und schneller. Und Sie wissen, wer in Ihrem Büro unterwegs ist, gerade wenn Schlüssel oder Zugangskarten übergeben werden.",
          "Fällt jemand aus, organisieren wir Ersatz, ohne dass Sie sich darum kümmern müssen. Das ist der Kern unserer Arbeit: koordinieren, damit es bei Ihnen einfach läuft.",
        ],
      },
      {
        h2: "Mehr als nur Unterhaltsreinigung",
        paragraphs: [
          "Neben der regelmäßigen Reinigung planen wir auf Wunsch auch Fensterreinigung, Grundreinigung nach Renovierungen oder eine Sonderreinigung vor wichtigen Kundenterminen. Alles kommt aus einer Hand und wird transparent abgerechnet.",
          "Wenn Sie später noch weitere Leistungen brauchen, etwa Hausmeisterdienste oder Winterdienst für den Parkplatz, läuft das ebenfalls über denselben Kontakt.",
        ],
      },
      {
        h2: "Hygiene, die man sieht und spürt",
        paragraphs: [
          "Gerade in Büros mit Kundenverkehr zählt der erste Eindruck. Ein sauberer Empfang, frische Toiletten und ordentliche Besprechungsräume zeigen, dass Sie Ihre Gäste ernst nehmen. Gleichzeitig sinkt die Zahl der Krankheitstage, wenn Kontaktflächen regelmäßig gereinigt werden. Das ist kein großer Aufwand, wenn es von Anfang an gut geplant ist, und genau das übernehmen wir für Sie.",
        ],
      },
    ],
    areasText:
      "Neben Aschaffenburg selbst organisieren wir Reinigung auch in Goldbach, Hösbach, Mainaschaff und Stockstadt sowie auf der hessischen Seite.",
    faq: [
      { q: "Arbeitet ManageMatch wirklich in Aschaffenburg, obwohl der Sitz in Hanau ist?", a: "Ja. Aschaffenburg ist rund 30 Minuten entfernt und gehört fest zu unserem Einsatzgebiet. Viele unserer Teams wohnen in der Region." },
      { q: "Wie schnell kann die Büroreinigung starten?", a: "Nach Besichtigung und Angebot meist innerhalb von ein bis zwei Wochen, bei dringendem Bedarf auch schneller." },
      { q: "Gibt es eine Mindestlaufzeit?", a: "Wir arbeiten mit fairen Laufzeiten, die wir im Angebot klar benennen. Lange Knebelverträge gibt es bei uns nicht." },
      { q: "Wer ist mein Ansprechpartner?", a: "Sie bekommen eine feste Kontaktperson bei ManageMatch, die telefonisch, per WhatsApp und per E-Mail erreichbar ist." },
    ],
    related: [
      { to: "/bueroreinigung-hanau", label: "Büroreinigung in Hanau" },
      { to: "/winterdienst-hanau", label: "Winterdienst für Aschaffenburg und Umgebung" },
      { to: "/post-event-cleaning", label: "Reinigung nach Veranstaltungen" },
    ],
  },
  {
    slug: "it-dienstleistung-hanau",
    keyword: "IT Dienstleistung Hanau",
    title: "IT Dienstleistung Hanau: Support ohne Umwege | ManageMatch",
    description:
      "IT Dienstleistung Hanau für kleine Firmen: Support, Netzwerk, Geräte und Updates, koordiniert von einem Ansprechpartner. Jetzt Beratung anfragen.",
    h1: "IT Dienstleistung Hanau für kleine Unternehmen",
    eyebrow: "Digital & IT",
    heroAlt: "IT Dienstleistung Hanau: Techniker richtet Arbeitsplatzrechner ein",
    image: itHero.url,
    serviceType: "IT Dienstleistung",
    intro: [
      "Wenn der Drucker streikt, das WLAN ständig abbricht oder ein neuer Mitarbeiter morgen einen Laptop braucht, soll es schnell gehen. Unsere IT Dienstleistung Hanau richtet sich an kleine Betriebe, Praxen und Büros, die keine eigene IT Abteilung haben und trotzdem verlässliche Technik wollen.",
      "ManageMatch koordiniert dafür erfahrene IT Fachleute aus der Region. Sie haben einen Kontakt, schildern Ihr Problem und wir sorgen dafür, dass die richtige Person sich darum kümmert.",
    ],
    sections: [
      {
        h2: "Wobei unsere IT Dienstleistung Hanau hilft",
        paragraphs: [
          "Typische Aufgaben sind die Einrichtung von Arbeitsplätzen, Netzwerk und WLAN, Drucker und Scanner, E-Mail Konten und Microsoft 365, Datensicherung sowie regelmäßige Updates. Auch bei der Frage, welche Hardware sich wirklich lohnt, bekommen Sie eine ehrliche Einschätzung.",
          "Viele Probleme lassen sich per Fernwartung in wenigen Minuten lösen. Wenn jemand vor Ort sein muss, stimmen wir einen Termin ab, der Ihren Betrieb möglichst wenig stört.",
        ],
      },
      {
        h2: "Klare Absprachen statt Fachchinesisch",
        paragraphs: [
          "Sie müssen kein Technikprofi sein, um mit uns zu sprechen. Wir erklären, was passiert, warum es passiert und was es kostet, bevor etwas gemacht wird. Keine Überraschungen auf der Rechnung, keine Abos, die niemand braucht.",
          "Auf Wunsch dokumentieren wir Ihre Umgebung, also Passwörter, Geräte und Lizenzen, damit Sie jederzeit den Überblick behalten.",
        ],
      },
      {
        h2: "Vorbeugen ist günstiger als reparieren",
        paragraphs: [
          "Der teuerste IT Ausfall ist der, der mitten im Tagesgeschäft passiert. Deshalb empfehlen wir kleinen Firmen einen einfachen Wartungsrhythmus: Updates prüfen, Backups testen, Geräte kurz durchsehen. Das dauert wenig und verhindert viel.",
          "Wenn Ihre Firma wächst, wächst die Betreuung einfach mit. Ob zwei oder zwanzig Arbeitsplätze, das Prinzip bleibt gleich.",
        ],
      },
      {
        h2: "Sicherheit ohne Panikmache",
        paragraphs: [
          "Phishing Mails, veraltete Router, Passwörter auf Post-its: Die meisten Sicherheitslücken in kleinen Firmen sind ganz alltäglich. Wir schauen gemeinsam, wo die größten Risiken liegen, und beheben sie Schritt für Schritt. Dazu gehören sichere Passwörter, eine funktionierende Datensicherung und ein kurzer Hinweis an Ihr Team, worauf es achten sollte. Ohne Angstmache, aber mit Wirkung.",
        ],
      },
    ],
    areasText:
      "Wir betreuen Betriebe in Hanau und im gesamten Main-Kinzig-Kreis, dazu per Fernwartung auch Kunden im weiteren Rhein-Main-Gebiet.",
    faq: [
      { q: "Wie schnell reagiert der IT Support?", a: "Anfragen beantworten wir in der Regel am selben Tag. Dringende Störungen werden bevorzugt behandelt, oft direkt per Fernwartung." },
      { q: "Brauche ich einen Wartungsvertrag?", a: "Nein. Sie können einzelne Einsätze buchen. Für Firmen mit regelmäßigem Bedarf lohnt sich meist eine monatliche Pauschale, das besprechen wir gemeinsam." },
      { q: "Kümmert ihr euch auch um Microsoft 365 und E-Mail?", a: "Ja, Einrichtung, Umzug von alten Postfächern und die Verwaltung von Konten gehören zu den häufigsten Aufgaben." },
      { q: "Wer arbeitet an meinen Geräten?", a: "Erfahrene IT Fachleute aus unserem regionalen Netzwerk. ManageMatch koordiniert die Einsätze und bleibt Ihr Ansprechpartner." },
    ],
    related: [
      { to: "/dienstleister-koordinieren", label: "Ein Ansprechpartner für alle Dienstleistungen" },
      { to: "/elektrotechnik-hanau", label: "Elektrotechnik in Hanau für Büro und Gewerbe" },
      { to: "/bueroreinigung-hanau", label: "Büroreinigung in Hanau" },
    ],
  },
  {
    slug: "reinigung-maintal",
    keyword: "Reinigung Maintal",
    title: "Reinigung Maintal: Sauber ohne Aufwand | ManageMatch",
    description:
      "Reinigung Maintal für Büro, Praxis, Treppenhaus und Wohnung. Feste Teams, ein Ansprechpartner. Jetzt kostenlos und unverbindlich anfragen.",
    h1: "Reinigung Maintal für Gewerbe und Zuhause",
    eyebrow: "Reinigung",
    heroAlt: "Reinigung Maintal: frisch geputzter Eingangsbereich mit glänzendem Boden",
    image: cleaningResult.url,
    serviceType: "Reinigung",
    intro: [
      "Ob Dörnigheim, Bischofsheim, Hochstadt oder Wachenbuchen: Wer eine Reinigung Maintal sucht, möchte meistens vor allem eins, dass es zuverlässig klappt. ManageMatch organisiert Reinigungen für Büros, Praxen, Treppenhäuser und Privathaushalte in allen Maintaler Stadtteilen.",
      "Wir sind direkt nebenan in Hanau zuhause und kennen die Ecken. Das heißt kurze Wege, flexible Termine und Teams, die auch mal kurzfristig einspringen können.",
    ],
    sections: [
      {
        h2: "Welche Reinigung Maintal wir organisieren",
        paragraphs: [
          "Am häufigsten fragen uns Kunden nach der regelmäßigen Unterhaltsreinigung für Büros und kleine Gewerbeflächen. Danach kommen Treppenhausreinigung für Mehrfamilienhäuser, Praxisreinigung mit besonderen Hygieneanforderungen und Endreinigungen beim Auszug.",
          "Auch Fensterreinigung und Grundreinigung nach Handwerkerarbeiten gehören dazu. Wenn Sie nicht sicher sind, was Sie genau brauchen, rufen Sie einfach an. Wir finden das gemeinsam heraus.",
        ],
      },
      {
        h2: "Für Hausverwaltungen und Eigentümer",
        paragraphs: [
          "Gerade Hausverwaltungen schätzen, dass sie bei uns nicht jede Kleinigkeit selbst hinterhertelefonieren müssen. Wir organisieren Treppenhausreinigung, Mülltonnendienst und auf Wunsch Winterdienst und Grünpflege. Sie bekommen eine Übersicht, was wann erledigt wurde.",
          "Mieter haben eine Nummer, unter der sie sich melden können, und Sie haben einen Ansprechpartner statt fünf.",
        ],
      },
      {
        h2: "Ehrliche Preise, klare Leistungen",
        paragraphs: [
          "Bevor wir ein Angebot machen, schauen wir uns das Objekt an oder lassen uns Fotos und Grundriss schicken. So wissen beide Seiten, worüber wir sprechen. Das Angebot listet genau auf, was gemacht wird und wie oft.",
          "Wenn sich später etwas ändert, passen wir den Plan an. Kein Kleingedrucktes, keine Diskussion bei der Rechnung.",
        ],
      },
      {
        h2: "Kurze Wege aus Hanau",
        paragraphs: [
          "Weil unser Büro nur wenige Minuten entfernt liegt, können wir in Maintal auch spontan reagieren. Wenn nach einer Feier, einem Wasserschaden oder vor einer Wohnungsübergabe schnell geputzt werden muss, finden wir meistens einen Termin in den nächsten Tagen. Und bei regelmäßigen Reinigungen sorgt die Nähe dafür, dass Vertretungen im Krankheitsfall schnell organisiert sind und Ihre Räume nicht liegen bleiben.",
        ],
      },
    ],
    areasText:
      "In Maintal sind wir in allen vier Stadtteilen unterwegs und organisieren auch Einsätze in Bruchköbel, Niederdorfelden und Frankfurt Bergen-Enkheim.",
    faq: [
      { q: "Reinigt ihr auch Privatwohnungen in Maintal?", a: "Ja, zum Beispiel regelmäßige Haushaltsreinigung oder eine Endreinigung beim Auszug. Sprechen Sie uns einfach an." },
      { q: "Wie kurzfristig bekomme ich einen Termin?", a: "Für einmalige Reinigungen oft innerhalb weniger Tage. Regelmäßige Termine starten nach kurzer Abstimmung." },
      { q: "Übernehmt ihr die Treppenhausreinigung für unser Haus?", a: "Gern. Wir organisieren feste Intervalle und dokumentieren die Einsätze für Verwaltung und Eigentümer." },
      { q: "Was brauche ich für ein Angebot?", a: "Adresse, ungefähre Fläche und was gereinigt werden soll. Fotos helfen, eine Besichtigung ist aber auch jederzeit möglich." },
    ],
    related: [
      { to: "/reinigung-hanau", label: "Reinigung in Hanau, Rodenbach und Langenselbold" },
      { to: "/bueroreinigung-hanau", label: "Büroreinigung in Hanau" },
      { to: "/winterdienst-hanau", label: "Winterdienst und Schneeräumung" },
    ],
  },
  {
    slug: "reinigung-hanau",
    keyword: "Reinigung Hanau",
    title: "Reinigung Hanau: Alles sauber, ein Kontakt | ManageMatch",
    description:
      "Reinigung Hanau, Rodenbach und Langenselbold: Büro, Treppenhaus, Praxis und Endreinigung, organisiert von ManageMatch. Jetzt Angebot anfragen.",
    h1: "Reinigung Hanau, Rodenbach und Langenselbold",
    eyebrow: "Reinigung",
    heroAlt: "Reinigung Hanau: Reinigungskraft wischt einen hellen Flur",
    image: reinigungHero.url,
    serviceType: "Reinigung",
    intro: [
      "Eine Reinigung Hanau zu finden ist leicht. Eine, die dauerhaft zuverlässig ist, schon weniger. Genau hier setzt ManageMatch an: Wir organisieren Reinigungen für Gewerbe, Hausverwaltungen und Privatkunden und bleiben dran, damit die Qualität auch nach drei Monaten noch stimmt.",
      "Unser Büro ist in Hanau, unsere Teams sind in der ganzen Umgebung unterwegs, auch in Rodenbach und Langenselbold.",
    ],
    sections: [
      {
        h2: "Reinigung Hanau für jeden Bedarf",
        paragraphs: [
          "Wir organisieren Unterhaltsreinigung für Büros und Praxen, Treppenhausreinigung, Glas- und Fensterreinigung, Grundreinigung nach Renovierung sowie Endreinigung bei Aus- oder Einzug. Für Gastronomie und Handel planen wir Reinigungen gern außerhalb der Öffnungszeiten.",
          "Alles kommt über einen Kontakt. Wenn Sie später noch Hausmeisterservice oder Gartenpflege brauchen, erweitern wir einfach den Plan.",
        ],
      },
      {
        h2: "Reinigung in Rodenbach",
        paragraphs: [
          "In Rodenbach betreuen wir vor allem kleinere Gewerbebetriebe und Mehrfamilienhäuser. Die Wege aus Hanau sind kurz, deshalb klappen auch kurzfristige Einsätze gut, etwa wenn nach einem Wasserschaden oder vor einer Wohnungsübergabe schnell geputzt werden muss.",
        ],
      },
      {
        h2: "Reinigung in Langenselbold",
        paragraphs: [
          "Langenselbold wächst, und mit den neuen Gewerbeflächen wächst auch der Bedarf an verlässlicher Reinigung. Wir organisieren dort Büro- und Hallenreinigung, Treppenhäuser und Sonderreinigungen. Die Termine richten sich nach Ihrem Betrieb, nicht umgekehrt.",
        ],
      },
      {
        h2: "Worauf Sie sich verlassen können",
        paragraphs: [
          "Feste Teams, die Ihr Objekt kennen. Ein Ansprechpartner, der sieben Tage die Woche erreichbar ist. Und ein Angebot, in dem genau steht, was gemacht wird. Wenn mal etwas nicht passt, sagen Sie es uns, und wir kümmern uns darum, ohne lange Diskussion.",
        ],
      },
      {
        h2: "Umweltbewusst reinigen",
        paragraphs: [
          "Wir achten darauf, dass Reinigungsmittel sparsam und passend zur Oberfläche eingesetzt werden. Das schont Böden und Möbel, spart Geld und ist besser für die Umwelt. Wenn Sie Wert auf zertifizierte Produkte legen, sagen Sie es uns einfach. Viele Kunden in Hanau fragen inzwischen gezielt danach, und wir berücksichtigen das bei der Planung ganz selbstverständlich.",
        ],
      },
    ],
    areasText:
      "Neben Hanau, Rodenbach und Langenselbold sind wir auch in Erlensee, Bruchköbel, Großkrotzenburg und Hainburg im Einsatz.",
    faq: [
      { q: "Welche Reinigungen organisiert ManageMatch in Hanau?", a: "Büro und Praxis, Treppenhaus, Fenster, Grundreinigung, Endreinigung und Sonderreinigungen. Für ungewöhnliche Anfragen finden wir meist auch eine Lösung." },
      { q: "Seid ihr auch in Rodenbach und Langenselbold unterwegs?", a: "Ja, beide Orte gehören fest zu unserem Einsatzgebiet, genau wie Maintal, Erlensee und Bruchköbel." },
      { q: "Kann ich eine einmalige Reinigung buchen?", a: "Natürlich. Endreinigung, Grundreinigung oder eine Reinigung nach Handwerkerarbeiten sind auch einmalig möglich." },
      { q: "Wie läuft die Abrechnung?", a: "Bei regelmäßigen Reinigungen monatlich zu einem festen Betrag, bei Einzelaufträgen nach vorher vereinbartem Festpreis." },
      { q: "Was passiert, wenn ich unzufrieden bin?", a: "Sie melden sich bei Ihrem Ansprechpartner, wir klären das und bessern nach. Das gehört für uns selbstverständlich dazu." },
    ],
    related: [
      { to: "/reinigung-maintal", label: "Reinigung in Maintal" },
      { to: "/bueroreinigung-hanau", label: "Büroreinigung in Hanau" },
      { to: "/post-event-cleaning", label: "Endreinigung nach einem Event" },
    ],
  },
  {
    slug: "winterdienst-hanau",
    keyword: "Winterdienst Hanau",
    title: "Winterdienst Hanau: Sichere Wege im Winter | ManageMatch",
    description:
      "Winterdienst Hanau und Schneeräumung Hanau: Räumen, Streuen, Dokumentation. Auch Aschaffenburg und Langenselbold. Jetzt für den Winter anfragen.",
    h1: "Winterdienst Hanau und Schneeräumung",
    eyebrow: "Winterdienst",
    heroAlt: "Winterdienst Hanau: geräumter und gestreuter Gehweg vor einem Wohnhaus",
    image: winterHero.url,
    serviceType: "Winterdienst",
    intro: [
      "Wenn es nachts schneit, muss der Gehweg morgens frei sein. So will es die Räum- und Streupflicht, und so wollen es auch Ihre Mieter, Kunden und Mitarbeiter. Unser Winterdienst Hanau sorgt dafür, dass Wege, Eingänge und Parkplätze rechtzeitig geräumt und gestreut sind.",
      "ManageMatch organisiert die Einsätze, behält das Wetter im Blick und dokumentiert jede Tour. Sie müssen nicht um sechs Uhr aus dem Fenster schauen.",
    ],
    sections: [
      {
        h2: "Schneeräumung Hanau: was dazugehört",
        paragraphs: [
          "Zur Schneeräumung Hanau gehören das Räumen von Gehwegen, Hauszugängen, Treppen und Stellplätzen sowie das Streuen bei Glätte. In Hanau gilt die Räumpflicht werktags in der Regel ab 7 Uhr, am Wochenende etwas später. Wir planen die Touren so, dass Ihre Flächen vorher fertig sind.",
          "Jeder Einsatz wird mit Datum und Uhrzeit protokolliert. Das ist wichtig, falls es doch einmal zu einem Sturz kommt und Sie nachweisen müssen, dass geräumt wurde.",
        ],
      },
      {
        h2: "Winterdienst in Aschaffenburg",
        paragraphs: [
          "Auch in Aschaffenburg organisieren wir Winterdienst für Gewerbeobjekte und Wohnanlagen. Die Satzung dort weicht in Details von Hanau ab, zum Beispiel bei Zeiten und Streumitteln. Wir kennen die Regeln und richten die Touren danach aus.",
        ],
      },
      {
        h2: "Winterdienst in Langenselbold",
        paragraphs: [
          "In Langenselbold betreuen wir vor allem Mehrfamilienhäuser und kleinere Firmengelände. Weil die Stadt etwas höher liegt als Hanau, kommt der Schnee dort manchmal früher. Unsere Teams sind darauf eingestellt und rücken bei Bedarf zuerst dort aus.",
        ],
      },
      {
        h2: "Rechtzeitig planen lohnt sich",
        paragraphs: [
          "Die Kapazitäten für den Winter sind begrenzt. Wer im Oktober anfragt, hat meistens die größte Auswahl. Wir schauen uns Ihre Flächen an, legen fest, was geräumt werden soll, und machen ein Pauschalangebot für die Saison. Dann ist das Thema erledigt, bevor der erste Frost kommt.",
        ],
      },
      {
        h2: "Was Eigentümer wissen sollten",
        paragraphs: [
          "Die Räumpflicht lässt sich zwar an Mieter oder Dienstleister übertragen, die Kontrollpflicht bleibt aber beim Eigentümer. Mit einem dokumentierten Winterdienst sind Sie auf der sicheren Seite. Wir schicken Ihnen auf Wunsch nach jedem Einsatz eine kurze Meldung, damit Sie auch aus der Ferne wissen, dass alles erledigt ist.",
        ],
      },
    ],
    areasText:
      "Winterdienst organisieren wir in Hanau, Maintal, Rodenbach, Langenselbold, Aschaffenburg und den umliegenden Gemeinden.",
    faq: [
      { q: "Ab wann muss in Hanau geräumt sein?", a: "Werktags in der Regel ab 7 Uhr, an Sonn- und Feiertagen etwas später. Maßgeblich ist die aktuelle Satzung der Stadt, die wir bei der Planung berücksichtigen." },
      { q: "Wird jeder Einsatz dokumentiert?", a: "Ja, mit Datum, Uhrzeit und Art des Einsatzes. Die Protokolle bekommen Sie auf Wunsch jederzeit." },
      { q: "Wie wird abgerechnet?", a: "Meist als Saisonpauschale, damit Sie planen können. Für kleinere Flächen sind auch Einzeleinsätze möglich." },
      { q: "Übernehmt ihr auch Aschaffenburg und Langenselbold?", a: "Ja, beide Orte gehören zum Einsatzgebiet, jeweils mit Blick auf die örtlichen Regeln." },
    ],
    related: [
      { to: "/reinigung-hanau", label: "Reinigung in Hanau und Umgebung" },
      { to: "/dienstleister-koordinieren", label: "Winterdienst, Reinigung und Hausmeister aus einer Hand" },
      { to: "/bueroreinigung-aschaffenburg", label: "Büroreinigung in Aschaffenburg" },
    ],
  },
  {
    slug: "post-event-cleaning",
    keyword: "Post-Event Cleaning",
    title: "Post-Event Cleaning Hanau: Schnell sauber | ManageMatch",
    description:
      "Post-Event Cleaning in Hanau und Rhein-Main: Reinigung nach Veranstaltung und Endreinigung Event, auch nachts. Jetzt Termin anfragen.",
    h1: "Post-Event Cleaning in Hanau und Rhein-Main",
    eyebrow: "Events",
    heroAlt: "Post-Event Cleaning: Team räumt einen Veranstaltungssaal nach einer Feier auf",
    image: reinigungsserviceHero.url,
    serviceType: "Reinigung nach Veranstaltung",
    intro: [
      "Die Party war super, die Gäste sind weg, und jetzt sieht der Saal aus wie nach einem Sturm. Genau dafür gibt es Post-Event Cleaning. ManageMatch organisiert die Reinigung nach Firmenfeiern, Hochzeiten, Messen, Vereinsfesten und Konzerten, damit die Location pünktlich übergeben werden kann.",
      "Sie feiern, wir kümmern uns um den Rest. Und zwar dann, wann es gebraucht wird, auch nachts oder am frühen Sonntagmorgen.",
    ],
    sections: [
      {
        h2: "Post-Event Cleaning: was wir übernehmen",
        paragraphs: [
          "Dazu gehören Müll einsammeln und trennen, Böden reinigen, Tische und Stühle säubern, Toiletten und Küche wieder in Ordnung bringen und auf Wunsch auch den Außenbereich. Glasbruch, verschüttete Getränke und Konfetti in jeder Ritze kennen wir.",
          "Wenn die Location eine Übergabe mit Protokoll verlangt, planen wir das mit ein und sind bei Bedarf dabei.",
        ],
      },
      {
        h2: "Reinigung nach Veranstaltung mit festem Zeitfenster",
        paragraphs: [
          "Bei Events zählt die Uhr. Oft muss der Raum am nächsten Morgen schon wieder bereit sein. Deshalb stimmen wir vorher genau ab, wann das Team anrückt, wie viele Leute gebraucht werden und bis wann alles fertig ist. Bei größeren Veranstaltungen kann auch schon während des Events ein Team für Zwischenreinigungen da sein.",
        ],
      },
      {
        h2: "Endreinigung Event für Veranstalter und Locations",
        paragraphs: [
          "Viele Locations in Hanau und Umgebung verlangen eine Endreinigung Event oder berechnen sie teuer nach. Mit uns haben Sie die Kosten vorher im Blick und können die Kaution entspannt zurückbekommen.",
          "Auch Locations selbst arbeiten mit uns, wenn ihr eigenes Personal an Wochenenden knapp ist. Wir springen ein und halten den Betrieb am Laufen.",
        ],
      },
    ],
    areasText:
      "Post-Event Cleaning organisieren wir in Hanau, Maintal, Rodenbach, Langenselbold, Aschaffenburg und bei größeren Events auch in Frankfurt und Offenbach.",
    faq: [
      { q: "Wie kurzfristig kann ich eine Reinigung nach der Veranstaltung buchen?", a: "Am besten ein bis zwei Wochen vorher. Kurzfristige Anfragen versuchen wir trotzdem möglich zu machen, rufen Sie einfach an." },
      { q: "Reinigt ihr auch nachts direkt nach dem Event?", a: "Ja, wenn die Location das erlaubt. Viele Einsätze beginnen direkt nach dem Ende der Veranstaltung." },
      { q: "Was kostet eine Endreinigung nach einem Event?", a: "Das hängt von Fläche, Gästezahl und Art der Veranstaltung ab. Nach ein paar Infos bekommen Sie einen Festpreis." },
      { q: "Nehmt ihr den Müll mit?", a: "Auf Wunsch ja. Wir klären vorher, was die Location bereitstellt und was abtransportiert werden muss." },
    ],
    related: [
      { to: "/reinigung-hanau", label: "Reinigung in Hanau für Gewerbe und Privat" },
      { to: "/bueroreinigung-hanau", label: "Büroreinigung nach der Firmenfeier" },
      { to: "/dienstleister-koordinieren", label: "Koordinationsservice für Ihr Event" },
    ],
  },
  {
    slug: "dienstleister-koordinieren",
    keyword: "verschiedene Dienstleister koordinieren",
    title: "Dienstleister koordinieren Hanau: Ein Kontakt | ManageMatch",
    description:
      "Verschiedene Dienstleister koordinieren kostet Zeit. Unser Koordinationsservice in Hanau: ein Ansprechpartner für alle Dienstleistungen. Jetzt anfragen.",
    h1: "Verschiedene Dienstleister koordinieren in Hanau",
    eyebrow: "Koordinationsservice",
    heroAlt: "verschiedene Dienstleister koordinieren: Planungstafel mit Terminen für Reinigung, Hausmeister und Technik",
    image: hausmeisterHero.url,
    serviceType: "Koordinationsservice",
    intro: [
      "Reinigung, Hausmeister, Winterdienst, Elektriker, IT: Wer verschiedene Dienstleister koordinieren muss, telefoniert viel, wartet oft und behält trotzdem selten den Überblick. ManageMatch nimmt Ihnen genau diese Arbeit ab. Sie haben einen Kontakt, wir kümmern uns um den Rest.",
      "Das Ganze funktioniert für Hausverwaltungen genauso wie für Büros, Praxen, Gastronomie oder Eigentümer mit mehreren Objekten rund um Hanau.",
    ],
    sections: [
      {
        h2: "Warum verschiedene Dienstleister koordinieren so anstrengend ist",
        paragraphs: [
          "Jede Firma hat andere Erreichbarkeiten, andere Rechnungen, andere Ansprechpartner. Fällt jemand aus, fängt die Suche von vorn an. Und wenn zwei Gewerke aufeinander warten, steht am Ende alles still.",
          "Das kostet Zeit, die eigentlich für Ihr Kerngeschäft da sein sollte. Viele Kunden sagen uns, dass sie erst gemerkt haben, wie viel Aufwand das war, als es weg war.",
        ],
      },
      {
        h2: "Unser Koordinationsservice im Überblick",
        paragraphs: [
          "Wir schauen uns an, welche Leistungen Sie brauchen, und stellen aus unserem regionalen Netzwerk die passenden Fachbetriebe zusammen. Wir planen Termine, stimmen Gewerke aufeinander ab, prüfen die Ergebnisse und sind Ihre Anlaufstelle für Fragen und Reklamationen.",
          "Sie bekommen eine klare Übersicht, was wann erledigt wurde, und auf Wunsch eine gebündelte Abrechnung.",
        ],
      },
      {
        h2: "Ein Ansprechpartner für alle Dienstleistungen",
        paragraphs: [
          "Das ist der eigentliche Kern: ein Ansprechpartner für alle Dienstleistungen. Eine Nummer, ein WhatsApp Chat, eine E-Mail Adresse. Egal ob die Heizung, die Treppenhausreinigung oder der Internetanschluss das Problem ist, Sie melden sich an einer Stelle und wir wissen, wer sich kümmert.",
          "Wir sind sieben Tage die Woche von 08:00 bis 20:00 Uhr erreichbar. Dringendes wird sofort weitergegeben.",
        ],
      },
      {
        h2: "Für wen sich das lohnt",
        paragraphs: [
          "Besonders für Hausverwaltungen mit mehreren Objekten, für kleine Unternehmen ohne eigene Facility Abteilung und für Eigentümer, die nicht in der Nähe wohnen. Aber auch wer nur zwei oder drei Dienstleister hat, merkt schnell, wie angenehm es ist, sich um nichts mehr kümmern zu müssen.",
        ],
      },
    ],
    areasText:
      "Unseren Koordinationsservice bieten wir in Hanau und im ganzen Main-Kinzig-Kreis an, dazu in Aschaffenburg und im östlichen Rhein-Main-Gebiet.",
    faq: [
      { q: "Was genau macht ManageMatch als Koordinator?", a: "Wir organisieren und koordinieren Fachbetriebe aus unserem Netzwerk, planen Termine, prüfen Ergebnisse und sind Ihr einziger Ansprechpartner." },
      { q: "Kann ich meine bisherigen Dienstleister behalten?", a: "Oft ja. Wir können auch bestehende Firmen in die Koordination einbinden, wenn die Zusammenarbeit gut läuft." },
      { q: "Welche Leistungen lassen sich koordinieren?", a: "Reinigung, Hausmeisterdienste, Winterdienst, Gartenpflege, Elektrotechnik, IT und Sicherheitsdienste, um die häufigsten zu nennen." },
      { q: "Was kostet der Koordinationsservice?", a: "Das hängt vom Umfang ab. Im Erstgespräch schauen wir, was Sie brauchen, und machen ein transparentes Angebot." },
    ],
    related: [
      { to: "/elektrotechnik-hanau", label: "Elektrotechnik in Hanau koordiniert" },
      { to: "/it-dienstleistung-hanau", label: "IT Dienstleistung in Hanau" },
      { to: "/winterdienst-hanau", label: "Winterdienst in Hanau" },
    ],
  },
  {
    slug: "elektrotechnik-hanau",
    keyword: "Elektriker Hanau",
    title: "Elektriker Hanau: Elektrotechnik koordiniert | ManageMatch",
    description:
      "Elektriker Hanau gesucht? ManageMatch koordiniert qualifizierte Elektrofachbetriebe für Büro, Gewerbe und E-Check. Jetzt Anfrage stellen.",
    h1: "Elektrotechnik in Hanau und Umgebung",
    eyebrow: "Elektrotechnik",
    heroAlt: "Elektriker Hanau: Elektrofachkraft prüft einen Sicherungskasten",
    image: elektroHero.url,
    serviceType: "Elektrotechnik",
    intro: [
      "Sie suchen einen Elektriker Hanau und haben keine Lust, fünf Betriebe abzutelefonieren, von denen drei nicht zurückrufen? ManageMatch koordiniert qualifizierte Elektrofachbetriebe aus unserem Netzwerk. Sie haben einen Ansprechpartner und bekommen schnell eine Rückmeldung.",
      "Wichtig vorab: Wir führen keine Elektroarbeiten selbst aus. Die Arbeiten übernehmen eingetragene Meisterbetriebe. Wir sorgen dafür, dass der passende Betrieb zu Ihnen kommt und alles sauber abläuft.",
    ],
    sections: [
      {
        h2: "Elektriker Hanau für Büro und Gewerbe",
        paragraphs: [
          "Viele Anfragen kommen von Firmen: ein Elektriker Büro und Gewerbe für zusätzliche Steckdosen, neue Beleuchtung, Netzwerkdosen oder die Umrüstung beim Mieterwechsel. Wir klären mit Ihnen, was gebraucht wird, und koordinieren einen Fachbetrieb, der dafür Zeit hat.",
          "Auch Hausverwaltungen nutzen uns, wenn im Treppenhaus das Licht ausfällt oder eine Wohnung vor der Neuvermietung durchgesehen werden soll.",
        ],
      },
      {
        h2: "Elektroinstallation Hanau und E-Check Gewerbe",
        paragraphs: [
          "Für eine Elektroinstallation Hanau, etwa bei Umbau oder Erweiterung, stimmen wir den Betrieb mit anderen Gewerken ab, damit niemand auf den anderen wartet.",
          "Beim E-Check Gewerbe geht es um die regelmäßige Prüfung ortsveränderlicher und fester Anlagen nach DGUV Vorschrift 3. Wir erinnern Sie an Fristen, koordinieren den Prüftermin und sorgen dafür, dass Sie das Prüfprotokoll bekommen.",
        ],
      },
      {
        h2: "Elektriker in der Nähe, ohne langes Suchen",
        paragraphs: [
          "Wer bei Google Elektriker in der Nähe eingibt, findet viele Namen, aber selten sofort einen freien Termin. Unser Netzwerk besteht aus Betrieben in Hanau und Umgebung, mit denen wir regelmäßig arbeiten. Das verkürzt die Wege und die Wartezeit.",
          "Für echte Notfälle, etwa einen kompletten Stromausfall im Betrieb, erreichen Sie uns telefonisch und wir geben die Anfrage sofort weiter.",
        ],
      },
      {
        h2: "So läuft eine Anfrage ab",
        paragraphs: [
          "Sie schildern uns kurz, worum es geht, gern mit ein paar Fotos. Wir klären offene Fragen, wählen einen passenden Fachbetrieb aus unserem Netzwerk und stimmen einen Termin mit Ihnen ab. Nach den Arbeiten fragen wir nach, ob alles passt. Wenn etwas nicht in Ordnung ist, kümmern wir uns darum. So haben Sie von der ersten Nachricht bis zur Rechnung einen festen Ansprechpartner.",
        ],
      },
    ],
    areasText:
      "Elektrofachbetriebe koordinieren wir in Hanau, Maintal, Rodenbach, Langenselbold, Aschaffenburg und im restlichen Main-Kinzig-Kreis.",
    faq: [
      { q: "Wie schnell bekomme ich einen Termin?", a: "Eine erste Rückmeldung bekommen Sie in der Regel am selben Tag. Der Termin selbst hängt von Umfang und Dringlichkeit ab, bei kleineren Arbeiten oft innerhalb weniger Tage." },
      { q: "Für welche Orte seid ihr da?", a: "Für Hanau, Maintal, Rodenbach, Langenselbold, Aschaffenburg und die umliegenden Gemeinden im Main-Kinzig-Kreis." },
      { q: "Was kostet ein Angebot?", a: "Die Anfrage und das Angebot sind für Sie kostenlos und unverbindlich. Bei größeren Vorhaben kann eine Besichtigung nötig sein, das klären wir vorher." },
      { q: "Wer führt die Arbeiten aus?", a: "Qualifizierte, eingetragene Elektrofachbetriebe aus unserem Netzwerk. ManageMatch führt keine Elektroarbeiten selbst aus, sondern koordiniert und bleibt Ihr Ansprechpartner." },
    ],
    related: [
      { to: "/dienstleister-koordinieren", label: "Ein Ansprechpartner für alle Dienstleister" },
      { to: "/it-dienstleistung-hanau", label: "IT Dienstleistung in Hanau" },
      { to: "/bueroreinigung-hanau", label: "Büroreinigung in Hanau" },
    ],
  },
];

export const WORK_AREAS = ["Hanau", "Maintal", "Rodenbach", "Langenselbold", "Aschaffenburg"];
